import React from "react";

const ITEMS = [
  "Avitaillement Maritime",
  "Logistique Internationale",
  "Import · Export",
  "Vente de Vivres",
  "Habillage de Conteneurs",
  "Commerce Général",
  "Livraison Sécurisée",
  "Approvisionnement Navires",
];

export default function MarqueeStrip() {
  // Duplicate twice for seamless loop
  const loop = [...ITEMS, ...ITEMS, ...ITEMS];

  return (
    <div
      data-testid="marquee-strip"
      className="relative bg-[#D90429] text-white overflow-hidden border-y border-[#0A1128]/10"
    >
      <div className="flex whitespace-nowrap animate-kms-marquee py-4">
        {loop.map((item, i) => (
          <div
            key={i}
            className="flex items-center gap-6 px-6"
          >
            <span className="font-heading font-black text-base sm:text-lg tracking-tight uppercase">
              {item}
            </span>
            <span className="w-2 h-2 bg-white/70 rotate-45" />
          </div>
        ))}
      </div>
      <style>{`
        @keyframes kms-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }
        .animate-kms-marquee {
          animation: kms-marquee 40s linear infinite;
        }
      `}</style>
    </div>
  );
}
